import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { setAddProductModalReducer } from '../../../redux/slices/components/Marketplace/marketplaceDataSlice'
import { useAppDispatch } from '../../../redux/store/store'
import "./HeaderMarketplace.css"

const HeaderMarketplace = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const onAddProduct = () => {
        dispatch( setAddProductModalReducer() )
    }

    const goProductsRequest = () => {
        navigate("/request-product")
    }

    return (
        <div className="flex flex-ai-center">
            <p className="title-screen">{t("Marketplace:label_01")}</p>

            <button 
                className="btn-beside-title-screen"
                onClick={goProductsRequest}
            >
                <FontAwesomeIcon icon={faPlus} className="fs-18-vh" />
                <p className="text-btn-title-screen">{t("ManageProducts:header:label_01")}</p>
            </button> 
        </div>
    )
}

export default React.memo( HeaderMarketplace )